import { FC, PropsWithChildren } from 'react';
import { StackProps } from '@mui/material';
import { DashboardCardStyled } from './dashboard-card.styles';

export const DashboardCard: FC<PropsWithChildren<StackProps>> = ({
  children,
  ...rest
}) => {
  return <DashboardCardStyled {...rest}>{children}</DashboardCardStyled>;
};
